import { createApp, h } from "vue"
import "./style.css"
import "@arcgis/core/assets/esri/themes/light/main.css"
import "@arcgis/map-components/arcgis-map-components/arcgis-map-components.css"
import "./assets/css/general.css"
import { createPinia } from "pinia"
import { usePaths } from "./utils/paths"
import { useStore } from "./store"

import App from "./App.vue"

const paths = usePaths()
const pinia = createPinia()

const app = createApp({
    map: undefined,
    view: undefined,
    render() {
        return h(App)
    },
})

app.use(pinia)

const store = useStore()
store.sourcesPath = paths.getSourcesPath()
store.tokensPath = paths.getTokensPath()

app.mount("#app")
